import { SkeletonLoader } from '@payaca/ambrosia';
import { FC } from 'react';

const UnscheduledItem: FC = () => (
  <div className="border rounded-lg p-3 flex flex-col gap-2">
    <SkeletonLoader.Text className="h-4 w-3/4" />
    <SkeletonLoader.Text className="h-3 w-1/2" />
  </div>
);

const SchedulePageSkeleton: FC = () => (
  <div className="flex w-full h-full bg-gray-50">
    <aside className="hidden xl:flex w-[350px] shrink-0 flex-col gap-4 p-8">
      <SkeletonLoader className="h-7 w-40 rounded" />
      <SkeletonLoader.Text className="h-4 w-48" />
      <div className="space-y-3">
        <UnscheduledItem />
        <UnscheduledItem />
        <UnscheduledItem />
        <UnscheduledItem />
        <UnscheduledItem />
      </div>
    </aside>

    <div className="flex grow flex-col gap-4 p-8 bg-white min-w-0">
      <div className="flex items-center gap-2 flex-wrap">
        <SkeletonLoader className="h-9 w-28 rounded-lg" />
        <SkeletonLoader className="h-9 w-36 rounded-lg" />
        <SkeletonLoader className="h-9 w-32 rounded-lg" />
        <SkeletonLoader className="h-9 w-24 rounded-lg ml-auto" />
      </div>

      <div className="grid grid-cols-7 gap-px border rounded-lg overflow-hidden bg-gray-200 flex-1 min-h-0">
        {Array.from({ length: 7 }).map((_, i) => (
          <div key={`h-${i}`} className="bg-gray-50 px-2 py-2">
            <SkeletonLoader.Text className="h-3 w-12" />
          </div>
        ))}
        {Array.from({ length: 35 }).map((_, i) => (
          <div
            key={`c-${i}`}
            className="bg-white p-2 flex flex-col gap-1 min-h-[80px]"
          >
            <SkeletonLoader.Text className="h-3 w-6" />
            {i % 3 === 0 && <SkeletonLoader className="h-4 w-full rounded" />}
            {i % 5 === 0 && <SkeletonLoader className="h-4 w-3/4 rounded" />}
          </div>
        ))}
      </div>
    </div>
  </div>
);

export default SchedulePageSkeleton;
